import useSWR from "swr";
import { JSON_FETCHER } from "@/components/fetcher";
import { Monitor } from "@/components/models/Monitor";
import { MonitorsCounts } from "@/components/models/MonitorsCounts";

export interface PaginationInfo {
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

export default function useDashboard(
  page: number = 1,
  perPage: number = 50,
  search: string = "",
): {
  monitors: Monitor[];
  monitors_counts: MonitorsCounts;
  pagination: PaginationInfo | null;
  isLoading: boolean;
  isError: any;
} {
  const queryParams = new URLSearchParams({
    page: page.toString(),
    per_page: perPage.toString(),
  });

  if (search) {
    queryParams.append("search", search);
  }

  const { data, error } = useSWR(`/web_api/dashboard?${queryParams}`, JSON_FETCHER, {
    refreshInterval: 60000,
  });

  return {
    monitors: data?.monitors || [],
    monitors_counts: data?.monitors_counts || {
      total: null,
      up: null,
      down: null,
      paused: null,
    },
    pagination: data?.pagination || null,
    isLoading: !(data || error),
    isError: error,
  };
}
